import { useEffect, useState } from "react";
import { permissionAction } from "../../utils/userInfo";

const allPermissionList = permissionAction();

const formatAction = (formatList) => {
  return formatList.reduce((a, v) => {
    const action = v.split("__")[2];
    return { ...a, [action]: v };
  }, {});
};

export const useBomPermission = () => {
  const [manufacturePermission, setManufacturePermission] = useState();

  useEffect(() => {
    const formatList = allPermissionList.filter((permission) =>
      permission.includes("MANUFACTURE__BOM")
    );
    const actions = formatAction(formatList);
    setManufacturePermission(actions);
  }, []);

  return manufacturePermission;
};

export const useManufactureOrderPermission = () => {
  const [manufacturePermission, setManufacturePermission] = useState();

  useEffect(() => {
    const formatList = allPermissionList.filter((permission) =>
      permission.includes("MANUFACTURE__ORDER")
    );
    const actions = formatAction(formatList);
    setManufacturePermission(actions);
  }, []);

  return manufacturePermission;
};

export const useWorkOrderPermission = () => {
  const [manufacturePermission, setManufacturePermission] = useState();

  useEffect(() => {
    const formatList = allPermissionList.filter((permission) =>
      permission.includes("MANUFACTURE__WORK_ORDER")
    );
    const actions = formatAction(formatList);
    setManufacturePermission(actions);
  }, []);

  return manufacturePermission;
};

export const useManufactureReportPermission = () => {
  const [manufacturePermission, setManufacturePermission] = useState();

  useEffect(() => {
    const formatList = allPermissionList.filter((permission) =>
      permission.includes("MANUFACTURE__REPORT")
    );
    const actions = formatAction(formatList);
    setManufacturePermission(actions);
  }, []);

  return manufacturePermission;
};
